import {
  FormRules,
  countryList,
} from '../utils/form'
import { i18n } from '../lang'

export const columnList = [
  { type: 'id', custom: { width: '64' } },
  { type: 'displayname', custom: { width: '200' } },
  // { type: 'gender', custom: { width: '70' } },
  { type: 'slug', custom: { width: '140' } },
  { type: 'bio', title: `${i18n.t('table.description')} (en)`, custom: { 'min-width': '140' } },
  { type: 'available_countries', custom: { width: '148' } },
]

const formRules = {
  required: [FormRules.required],
  requiredChange: [FormRules.requiredChange],
  id: [FormRules.required, FormRules.id],
  countries: [FormRules.requiredCountries],
}

export const brandFormTemplate = (isEdit) => {
  const template = [
    {
      key: 'id', isReadOnly: true,
    },
    {
      key: 'name', isInput: true, rules: formRules.required, title: i18n.t('table.name'),
    },
    {
      key: 'displayname', isInput: true, rules: formRules.required, title: i18n.t('table.displayname'),
    },
    {
      key: 'slug', isInput: true, rules: formRules.required, trim: true, title: i18n.t('table.slug'),
    },
    // {
    //   key: 'gender', isSelect: true, isDynamicLanguage: true, rules: formRules.required,
    // },
    {
      key: 'bio', isLocalized: true, isDynamicLanguage: true, title: i18n.t('table.description'),
    },
    {
      key: 'available_countries',
      isCheckbox: true,
      isCountry: true,
      title: i18n.t('table.availableCountries'),
      list: countryList,
    },
    {
      key: 'image',
      isInput: true,
      rules: [FormRules.imageUrl],
      trim: true,
      title: i18n.t('table.imageurl'),
    },
  ]

  let index
  if (isEdit) {
    index = template.findIndex(row => row.key === 'slug')
  } else {
    index = template.findIndex(row => row.key === 'id')
  }
  template.splice(index, 1)
  return template
}
